import { createTheme } from '@mui/material/styles';

// Cycling Buddy Color Palette - inspired by nature & cycling
export const cyclingBuddyTheme = createTheme({
  palette: {
    primary: {
      main: '#0e2c26',    // Deep Teal Green (matches CSS variables)
      light: '#1e4d40',   // Forest Teal 
      dark: '#0a1d1a',    // Very Dark Green
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#4d7c5a',    // Success Green
      light: '#c4e3c2',   // Light Mint
      dark: '#1f5d58',    // Slate Teal
      contrastText: '#ffffff',
    },
    // Keep other colors minimal to avoid conflicts
    success: {
      main: '#4d7c5a',    // Success Green
    },
    error: {
      main: '#7a1c1c',    // Error Red
    },
    warning: {
      main: '#b2a902',    // Olive Yellow
    },
    info: {
      main: '#1f5d58',    // Slate Teal
    },
    grey: {
      500: '#8a9a91',     // Muted Sage Gray (for the non-logged-in icon)
    },
  },
  typography: {
    fontFamily: 'system-ui, Avenir, Helvetica, Arial, sans-serif', // Match index.css
    h6: {
      fontWeight: 600,
    },
  },
  // Minimal component overrides - only what we specifically need
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0, // Remove rounded corners
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 0, // Remove rounded corners
        },
      },
    },
  },
});

export default cyclingBuddyTheme;
